import React from 'react';

import { TorchIcon } from '../../../../../assets/icons/TorchIcon';
import { TorchToggle } from '../styles';

interface Props {
  on: boolean;
  label: string;
  onToggle: () => void;
}

/**
 * Linterna. Solo se monta si el dispositivo declara la capacidad `torch`: un
 * botón que no hace nada es peor que no tenerlo.
 */
export const TorchButton = ({ on, label, onToggle }: Props): JSX.Element => (
  <TorchToggle
    type="button"
    $active={on}
    aria-pressed={on}
    aria-label={label}
    title={label}
    onClick={onToggle}
  >
    <TorchIcon active={on} />
  </TorchToggle>
);
